import React, { Component } from 'react';

class About extends Component {
  render() {
    if (this.props.sharedBasicInfo) {
      var profilepic = 'images/' + this.props.sharedBasicInfo.image;
    }
    if (this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.about;
      var hello = this.props.resumeBasicInfo.description_header;
      var about = this.props.resumeBasicInfo.description;
    }

    return (
      <section id='about'>
        <div className='col-md-12'>
          <h1 style={{ color: 'black' }}>
            <span>{sectionName}</span>
          </h1>
          <div className='row center mx-auto mb-5'>
            <div className='col-md-4 mb-5 center'>
              <div className='polaroid'>
                <span style={{ cursor: 'auto' }}>
                  <img
                    height='250px'
                    src={profilepic}
                    alt='Avatar placeholder'
                  />
                  <div className='affiliations'>
                    <a
                      href='https://www.akamai.com'
                      target='_blank'
                      rel='noopener noreferrer'
                      className='affiliation-link'
                    >
                      <img
                        className='affiliation-logo affiliation-akamai'
                        src='images/logos/akamai.png'
                        alt='Akamai Technologies'
                      />
                    </a>
                    <a
                      href='https://www.rvce.edu.in'
                      target='_blank'
                      rel='noopener noreferrer'
                      className='affiliation-link'
                    >
                      <img
                        className='affiliation-logo affiliation-rvce'
                        src='images/logos/rvce.png'
                        alt='RV College of Engineering'
                      />
                    </a>
                    <a
                      href='https://gmatclub.com'
                      target='_blank'
                      rel='noopener noreferrer'
                      className='affiliation-link'
                    >
                      <img
                        className='affiliation-logo affiliation-gmatclub'
                        src='images/logos/gmatclub.png'
                        alt='GMAT Club'
                      />
                    </a>
                    <a
                      href='https://www.avantifellows.org'
                      target='_blank'
                      rel='noopener noreferrer'
                      className='affiliation-link'
                    >
                      <img
                        className='affiliation-logo affiliation-avanti'
                        src='images/logos/avanti.png'
                        alt='Avanti Fellows'
                      />
                    </a>
                    <a
                      href='https://ffe.org'
                      target='_blank'
                      rel='noopener noreferrer'
                      className='affiliation-link affiliation-wide'
                    >
                      <img
                        className='affiliation-logo affiliation-ffe'
                        src='images/logos/ffe.png'
                        alt='Foundation For Excellence'
                      />
                    </a>
                  </div>
                </span>
              </div>
            </div>

            <div className='col-md-8 center'>
              <div className='col-md-10'>
                <div className='card'>
                  <div
                    className='card-body font-trebuchet text-justify ml-3 mr-3'
                    style={{
                      height: 'auto',
                      fontSize: '132%',
                      lineHeight: '200%',
                    }}
                  >
                    <br />
                    <span className='wave'>{hello} :) </span>
                    <br />
                    <br />
                    {about}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
